/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from './User';
export type Category = {
  /**
   * Unique category identifier
   */
  id: number;
  /**
   * Category name
   */
  name: string;
  /**
   * Category code
   */
  code: string;
  /**
   * Category description
   */
  description?: string;
  /**
   * Category status
   */
  status: Category.status;
  /**
   * Created by user
   */
  createdBy: User;
  /**
   * Updated by user
   */
  updatedBy: User;
  /**
   * Creation timestamp
   */
  createdAt: string;
  /**
   * Last update timestamp
   */
  updatedAt: string;
};
export namespace Category {
  /**
   * Category status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
}
